import { useMemo } from "react";

import { useSm } from "../../services";

export function useResponsiveLineChartStyles() {
  const sm = useSm();

  return useMemo(
    function () {
      if (sm) {
        return {
          barRadius: 6,
          barSize: 12,
          lineDot: { r: 4, strokeWidth: 3 },
          lineStrokeWidth: 3,
        };
      } else {
        return {
          barRadius: 3,
          barSize: 4,
          lineDot: { r: 2, strokeWidth: 2 },
          lineStrokeWidth: 2,
        };
      }
    },
    [sm],
  );
}
